import { render } from "./CartModel.vue?vue&type=template&id=dc606eac&scoped=true"
import script from "./CartModel.vue?vue&type=script&lang=js"
export * from "./CartModel.vue?vue&type=script&lang=js"

import "./CartModel.vue?vue&type=style&index=0&id=dc606eac&lang=scss&scoped=true"

import exportComponent from "F:\\ds_pc_new\\pc\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dc606eac"]])

export default __exports__